import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { WebDavService } from "../FileManager/webDavService";

export const useDocumentStore = defineStore('document/items', () => {
    const items = ref([]);
    const rootFolderHref = ref('');
    const currentFolderHref = ref('');
    const clipboardItems = ref([]);

    const selectedItems = computed(() => items.value.length > 0 ? items.value.filter(x => x.Selected) : []);

    // temp
    const fetchFolderItems1 = async (href) => {
        const nextHref = href.replace(/\/?$/, '/');

        let folder;

        try {
            currentFolderHref.value = nextHref;

            const response = await WebDavService.getCurrentFolder(nextHref);
            folder = response.Result;

            const itemsResult = await WebDavService.getItems(folder, null, true, 1, 25);


            items.value = itemsResult.Result.Page;
        } catch (error) {
            console.error('fetchFolderItems1 failed:', error);
            console.error('Message:', error?.Message);
            console.error('Status:', error?.Status);
            console.error('Multistatus:', error?.Multistatus);

            throw error;
        }
    };

    const fetchFolderItems = async () => {
        await fetchFolderItems1(currentFolderHref.value);
    };

    const refreshFolder = async (tryParent) => {
        await fetchFolderItems1(currentFolderHref.value);
    };

    const updateItem = async (itemPath) => {

        const item = items.value.find((p) => p.Href === itemPath);
        if (item && item.Href) {
            const index = items.value.map(x => x.Href).indexOf(itemPath);
            const response = await WebDavService.getItem(item.Href);
            if (response.IsSuccess) {
                items.value.splice(index, 1, response.Result);
            }
        }
    };

    const deleteSelectedItems = async () => {
        const itemsToDelete = [...selectedItems.value];

        if (itemsToDelete.length === 0) {
            return;
        }

        const deletePromises = itemsToDelete.map(item =>
            new Promise((resolve, reject) => {
                item.DeleteAsync(null, (data) => {
                    if (data.IsSuccess) {
                        resolve();
                        return;
                    }

                    reject(data);
                });
            })
        );

        await Promise.all(deletePromises);
    };

    const addUploadItem = (item) => {
        // items.value.push({ResourceType: '', DisplayName: '', ContentLength: 0, LastModified, IsUploading: true})
        // items.value.push(item);
    };

    const addSelectedItemsToClipboard = (action) => {
        selectedItems.value.forEach(item => {
            const clipboardItem = {
                Href: item.Href,
                DisplayName: item.DisplayName,
                ResourceType: item.ResourceType,
                Action: action,
            };

            const existingIndex = clipboardItems.value.findIndex(x => x.Href === item.Href);

            if (existingIndex >= 0) {
                clipboardItems.value.splice(existingIndex, 1, clipboardItem);
                return;
            }

            clipboardItems.value.push(clipboardItem);
        });
    };

    const copySelectedItems = () => {
        addSelectedItemsToClipboard('copy');
    };

    const cutSelectedItems = () => {
        addSelectedItemsToClipboard('cut');
    };

    const setRootFolder = (projectCode) => {
        rootFolderHref.value = `${process.env.VUE_APP_ROOT_WEBDAV}/dav/${projectCode}/`;
        currentFolderHref.value = rootFolderHref.value;
    };

    return {
        items,
        rootFolderHref,
        currentFolderHref,
        clipboardItems,
        copySelectedItems,
        cutSelectedItems,
        fetchFolderItems,
        refreshFolder,
        updateItem,
        fetchFolderItems1,
        selectedItems,
        deleteSelectedItems,
        addUploadItem,
        setRootFolder 
    }
});